const months = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC"
  ];
  
export default{
    convertDateFormat(inDate) {

        if (inDate === null || inDate === undefined || inDate === "") {
          return "";
        }

        let dbDateTime = new Date(inDate);

        if (isNaN(dbDateTime.getTime())) {
          return "";
        }

        let yr = dbDateTime.getFullYear();
        if (yr <= 1 || yr === 1970) {
          return "";
        }
      
        let formattedDate =
          dbDateTime.getDate() +
          "-" +
          months[dbDateTime.getMonth()] +
          "-" +
          yr;
        return formattedDate;
      },
      
      convertDateFormatYMD(inDate){
        let dbDateTime = new Date(inDate);
        let formattedDate = dbDateTime.getFullYear() + "-" + (dbDateTime.getMonth()+1) + "-" + dbDateTime.getDate();
        return formattedDate;
      }
}


// WEBPACK FOOTER //
// ./src/Formatter.js